import React from 'react';
import { useSelector } from 'react-redux';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { selectPageModelData } from '../../../store/pageModel';
import { breadcrumbsStyles } from './style';

export const PageBreadcrumbs = ({ wrapperClassName = '' }) => {
	const { breadcrumbs } = useSelector(selectPageModelData);

	if (!breadcrumbs.length) {
		return null;
	}

	return (
		<Breadcrumbs className={`${breadcrumbsStyles} ${wrapperClassName}`}>
			{breadcrumbs.map(({ label, link }) => (
				<BreadcrumbsItem key={`breadcrumb-${label}`} href={link}>
					{label}
				</BreadcrumbsItem>
			))}
		</Breadcrumbs>
	);
};
